
export const authFetch = async (url, options = {}, authContext = null, config = {}) => {
    const { token, login, logout } = authContext || {};
    const { skipLogoutOnFail = false } = config;
    
    const makeRequest = async (accessToken) => {
      const headers = {
        ...options.headers,
        Authorization: `Bearer ${accessToken}`,
      };
  
      return fetch(url, {
        ...options,
        headers,
      });
    };
  
    let res = await makeRequest(token);
  
    if (res.status === 401 && login && logout) {
      try {
        const refreshRes = await fetch(`${import.meta.env.VITE_BASE_URL}/api/auth/refresh-token`, {
          method: 'POST',
          credentials: 'include',
        });
  
        if (!refreshRes.ok) {
            if (!skipLogoutOnFail) {
              logout(); // ✅ only logout if not skipped
            }
            return null; // 🛑 stop gracefully
          }
  
        const data = await refreshRes.json();
        login(data.token);

        res = await makeRequest(data.token); // retry request
        return res
      } catch (err) {
        console.error('AuthFetch refresh error:', err);
        logout();
        return res;
      }
    }

    return res
  };
  